// extracted by css-extract-rspack-plugin
export default {"main":"CreateMail__main--YFn7q"};